import {Card} from "../model/types";
import {MainWeddingMobile} from "../ui/MainWeddingMobile";
import {MainWeddingDesktop} from "../ui/MainWeddingDesktop";
import {Link} from "@/shared/ui/Link";
import {Button} from "@/shared/ui/Button";
import styles from "./MainWedding.module.scss";

type Props = {
    titleSection: string;
    link: string;
    linkName: string;
    cards: Card[];
    isMobile: boolean;
}

export const MainWedding = ({titleSection, link, linkName, cards, isMobile}: Props) => {
    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <p className={styles.titleSection}>{titleSection}</p>
            </div>
            {isMobile ? <MainWeddingMobile cards={cards} /> : <MainWeddingDesktop cards={cards} />}
            <div className={`globalContainer`}>
                <Link href={link}><Button variant={`tertiary`} fullWidth>{linkName}</Button></Link>
            </div>
        </div>
    );
}
